<template>
  <div class="payment-modal" v-if="show">
    <div class="payment-modal-content">
      <span class="close" @click="closePaymentModal">&times;</span>
      <h1>Make a Payment</h1>
      <div class="transaction-breakup">
        <h2>Transaction Breakup</h2>
        <hr style="margin:0;">
        <div class="charge-item">
          <span class="charge-label">Energy Price:</span>
          <span class="charge-value">₹{{ totAmount }}</span>
        </div>
        <div class="charge-item">
          <span class="charge-label">Platform Fee(18% GST included):</span>
          <span class="charge-value">₹{{ discomCharges }}</span>
        </div>
        <div class="charge-item">
          <span class="charge-label">Wheeling Charges (UPERC):</span>
          <span class="charge-value">₹{{ crossWheelingCharges }}</span>
        </div>
        <div class="charge-item">
          <span class="charge-label">Other Charges:</span>
          <span class="charge-value">₹{{ otherCharges }}</span>
        </div>
        <div class="charge-item total">
          <span class="charge-label">Total Amount:</span>
          <span class="charge-value">₹{{ totalAmount }}</span>
        </div>
      </div>
      <div id="razorpay-container"></div>
      <div class="add-money-checkbox" v-if="this.walletBalance < this.totalAmount">
        <input type="checkbox" id="addMoney" @click="redirectToWallet">
        <label for="addMoney">Add Money</label>
      </div>
      <div class="payment_buttons">
        <button  type="submit" class="pay_now" @click="submitPayment" >Place Order</button>
        <button type="button" class="cancel_payment" @click="closePaymentModal">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import { useToast } from 'vue-toastification';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    totAmount: {
      type: Number,
      default: 0
    },
    discomCharges: {
      type: Number,
      default: 0
    },
    aggregatorFees: {
      type: Number,
      default: 0
    },
    crossWheelingCharges: {
      type: Number,
      default: 0
    },
    otherCharges: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      razorpayOptions: null,
      walletBalance: 0,
    };
  },
  computed: {
    totalAmount() {
      return (
        this.totAmount +
        this.discomCharges +
        this.crossWheelingCharges+
        this.otherCharges
      );
    }
  },
  methods: {
    submitPayment() {
      if (this.walletBalance < this.totalAmount) {
        this.showToast("Insufficient Balance", "Insufficient Balance", "error");
        return;
      }
      this.$emit('payment-success');
    },
    
    closePaymentModal() {
      this.$emit('close');
    },
    showToast(title, message) {
      const toast = useToast();
      toast.success(message, {
        title: title,
        timeout: 1000,
        position: 'top-right',
      });
    },
/**
 * Emits a custom event to trigger navigation to the wallet.
 */

    redirectToWallet() {
    this.$emit('redirect-to-wallet');
  }
  },
 async mounted() {
     this.walletBalance =await  UserService.getWalletBalance();
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.payment-modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width:90%;
}
.payment-modal-content h1 {
  color: #453a94;
  font-weight: 600;
}
.transaction-breakup {
  margin-bottom: 20px;
}
.transaction-breakup h2 {
  color: #453a94;
  margin-bottom: 10px;
  text-align: left;
  font-size: 20px;
}
.charge-item {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
  font-family: "Montserrat", sans-serif;
}
.charge-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.charge-value {
  font-size: 14px;
  font-weight: 500;
  color: #453a94;
}
.charge-item.total .charge-value {
  font-weight: 700;
}
.pay_now {
  padding: 10px 20px;
  color: white;
  border: none;
  display: block;
  border-radius: 20px;
  font-family: "Montserrat", sans-serif;
  background-color: #453a94;
}
.cancel_payment {
  padding: 10px 20px;
  color: #453a94;
  border: 1px solid #453a94;
  display: block;
  border-radius: 20px;
  font-family: "Montserrat", sans-serif;
  background-color: white;
}
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}
.payment_buttons {
  display: flex;
  justify-content: space-between;
}
.add-money-checkbox {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.add-money-checkbox label {
  margin-left: 10px;
  font-family: "Montserrat", sans-serif;
  color: #453a94;
}
</style>
